import React from 'react'
import { Link } from 'react-router-dom'
// store
import { routes } from '../../store/routes'
// components
import { Icon, Label } from 'semantic-ui-react'
import { useSelector } from 'react-redux'

const BasketIcon = () => {
    const basket = useSelector((state) => state.basket)
    const total = basket.future_events.length + basket.events.length

    return (
        <>
            {total > 0 && (
                <Link to={routes.BASKET} style={{ textDecoration: 'none' }}>
                    <div
                        style={{
                            zIndex: '100',
                            position: 'fixed',
                            right: '20px',
                            top: '25px',
                            padding: '1rem',
                            background: 'linear-gradient(135deg, #d60d8c 0%, #b00a75 100%)',
                            borderRadius: '50%',
                            width: '60px',
                            height: '60px',
                            boxShadow: '0 4px 16px rgba(214, 13, 140, 0.4)',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.1)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(214, 13, 140, 0.5)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(214, 13, 140, 0.4)';
                        }}
                    >
                        <Icon
                            name="shopping basket"
                            size="large"
                            style={{
                                color: 'white',
                                margin: 0
                            }}
                        />
                        <Label
                            circular
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                background: '#ff4444',
                                color: 'white',
                                border: '2px solid white',
                                minWidth: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                                fontWeight: 'bold',
                                padding: 0,
                                zIndex: '101',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                            }}
                        >
                            {total}
                        </Label>
                    </div>
                </Link>
            )}
        </>
    )
}

export default BasketIcon
